import * as React from 'react'
import { SVGProps } from 'react'
const SvgBurger = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M2.5 5.5h19v1h-19v-1ZM21.5 17.5h-19v1h19v-1ZM21.5 11.5h-19v1h19v-1Z"
      fill="#1C1915"
    />
  </svg>
)
export default SvgBurger
